(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  function setLayerInert(el, inert) {
    if (!el) return;
    el.inert = !!inert;
    el.setAttribute('aria-hidden', inert ? 'true' : 'false');
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function cartButtonLabel(count) {
    const n = Number(count) || 0;
    if (n === 0) return phsText('cartEmptyLabel', 'Winkelwagen, leeg');
    if (n === 1) return phsText('cartOneLabel', 'Winkelwagen, 1 product');
    return phsText('cartCountLabel', 'Winkelwagen, [count] producten').replace(/\[count\]/g, String(n));
  }

  function wishlistButtonLabel(saved, title) {
    const name = title || 'Product';
    const tpl = saved
      ? phsText('savedWishlistNamed', 'Bewaard: [title]')
      : phsText('saveWishlistNamed', 'Bewaar [title]');
    return tpl.replace(/\[title\]/g, name);
  }

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100).replace(/€\s+/, '€');
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  };

  const phsI18n = () => window.PHS_I18N || {};
  const phsText = (key, fallback) => {
    const value = phsI18n()[key];
    return value != null && value !== '' ? value : fallback;
  };
  const phsAmount = (template, amountHtml) =>
    String(template || '').replace('[amount]', amountHtml);

  const shortProductTitle = (title, max = 48) => {
    let t = String(title || '').trim();
    if (!t) return '';
    t = t
      .replace(/\s+van Evergetikon/gi, '')
      .replace(/\s+[–—-]\s+Evergetikon\b/gi, '')
      .replace(/\s*\|\s*Evergetikon\b/gi, '')
      .replace(/\s+[–—-]\s+Pure Health Store\b/gi, '')
      .replace(/\s+[–—]\s+/g, ' - ');
    const dash = t.match(/^(.+?)\s+-\s+(.+)$/);
    if (dash) {
      const tail = dash[2].toLowerCase();
      if (/natuurlijk|zonder|haarolie|100%|siliconen|evergetikon/.test(tail)) {
        t = dash[1].trim();
      }
    }
    t = t.replace(/\s{2,}/g, ' ').trim();
    if (max && t.length > max) t = t.slice(0, max).trimEnd() + '…';
    return t;
  };

  /* Reveal on scroll
     Use threshold 0: tall blocks (e.g. article body) can never reach a
     high intersection ratio on mobile, so they stayed opacity:0 forever. */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '48px 0px 48px 0px' })
    : null;

  qsa('[data-reveal]').forEach((el, i) => {
    el.style.transitionDelay = (i % 4) * 80 + 'ms';
    if (io) io.observe(el);
    else el.classList.add('is-in');
  });

  /* Keep above-the-fold / reading content visible without waiting for IO */
  qsa('.hero-phs [data-reveal], .about-hero [data-reveal], .article-page [data-reveal]').forEach((el) => {
    el.classList.add('is-in');
  });

  const drawer = qs('[data-side-cart]');
  const overlay = qs('[data-cart-overlay]');
  const cartAdded = qs('[data-cart-added]');
  setLayerInert(drawer, !(drawer && drawer.classList.contains('open')));
  setLayerInert(cartAdded, !(cartAdded && cartAdded.classList.contains('is-open')));
  const giftModalInit = qs('[data-free-gift-modal]');
  setLayerInert(giftModalInit, !(giftModalInit && !giftModalInit.hidden));
  const MOBILE_CART_MQ = window.matchMedia('(max-width: 749px)');

  function isMobileCart() {
    return MOBILE_CART_MQ.matches;
  }

  function setFormsTeaserHidden(hidden) {
    qsa('shopify-forms-embed').forEach((host) => {
      host.style.setProperty('display', hidden ? 'none' : '', 'important');
      host.style.setProperty('pointer-events', hidden ? 'none' : '', 'important');
      const root = host.shadowRoot;
      if (!root) return;
      let style = root.getElementById('phs-forms-hide-on-cart');
      if (hidden) {
        if (!style) {
          style = document.createElement('style');
          style.id = 'phs-forms-hide-on-cart';
          style.textContent = `
            :host, [data-layout="floating"], [data-current-step], [data-position],
            button[data-testid="form-teaser"], .app-embed-root {
              display: none !important;
              visibility: hidden !important;
              pointer-events: none !important;
              opacity: 0 !important;
            }
          `;
          root.appendChild(style);
        }
      } else if (style) {
        style.remove();
      }
    });
  }

  function isCustomerLoggedIn() {
    if (document.body.classList.contains('customer-logged-in')) return true;
    try {
      const meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || window.meta || {};
      return !!(meta.page && meta.page.customerId);
    } catch (e) {
      return false;
    }
  }

  function syncFormsTeaserVisibility() {
    /* Stiltepass: geen intro-tab op PDP/cart; elders pas na korte delay; nooit bij login/cart */
    const hide =
      isCustomerLoggedIn() ||
      document.body.classList.contains('side-cart-open') ||
      document.body.classList.contains('template-product') ||
      document.body.classList.contains('template-cart') ||
      !window.__phsFormsReady;
    setFormsTeaserHidden(hide);
  }

  window.__phsFormsReady = false;
  window.setTimeout(() => {
    window.__phsFormsReady = true;
    syncFormsTeaserVisibility();
  }, 14000);

  function closeCartAdded() {
    if (!cartAdded) return;
    cartAdded.classList.remove('is-open');
    const finish = () => {
      if (cartAdded.classList.contains('is-open')) return;
      cartAdded.hidden = true;
      setLayerInert(cartAdded, true);
      document.body.classList.remove('cart-added-open');
      if (!drawer || !drawer.classList.contains('open')) {
        document.body.style.overflow = '';
        syncFormsTeaserVisibility();
      }
    };
    window.setTimeout(finish, 360);
  }

  function showCartAdded(item, cart) {
    if (!cartAdded) {
      renderCart().then(openCart);
      return;
    }
    closeCart();
    const product = qs('[data-cart-added-product]', cartAdded);
    const total = qs('[data-cart-added-total]', cartAdded);
    const title = item.product_title || item.title || '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const image = item.image || (item.featured_image && item.featured_image.url) || '';
    const price = item.final_line_price != null ? item.final_line_price : item.line_price || item.price || 0;
    if (product) {
      product.innerHTML = `<div class="cart-added__line">
        ${image ? `<img src="${image}" alt="${escapeAttr(title)}" width="72" height="72">` : ''}
        <div>
          <strong>${title}</strong>
          ${variant ? `<span>${variant}</span>` : ''}
          <span class="cart-added__price">${money(price)}</span>
        </div>
      </div>`;
    }
    if (total) total.textContent = money(cart.total_price);
    updateMeter(cart);
    cartAdded.hidden = false;
    setLayerInert(cartAdded, false);
    cartAdded.classList.remove('is-open');
    document.body.classList.add('cart-added-open');
    document.body.style.overflow = 'hidden';
    setFormsTeaserHidden(true);
    renderCart();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => cartAdded.classList.add('is-open'));
    });
  }

  function closeExternalModals() {
    qsa(
      'shopify-forms-embed [aria-label="Close modal"], shopify-forms-embed [aria-label="Sluiten"]'
    ).forEach((btn) => {
      try {
        btn.click();
      } catch (e) {}
    });
  }

  function openCart() {
    closeCartAdded();
    closeMobileMenu();
    if (drawer) {
      drawer.classList.add('open');
      setLayerInert(drawer, false);
    }
    if (overlay) overlay.classList.add('open');
    document.body.classList.add('side-cart-open');
    document.body.style.overflow = 'hidden';
    setFormsTeaserHidden(true);
    closeExternalModals();
    renderCart().then(() => {
      const scroll = qs('.side-cart__scroll', drawer);
      if (scroll) scroll.scrollTop = 0;
      const closeBtn = qs('[data-cart-close]', drawer);
      if (closeBtn) closeBtn.focus();
    });
  }

  function closeCart() {
    if (drawer) {
      drawer.classList.remove('open');
      setLayerInert(drawer, true);
    }
    if (overlay) overlay.classList.remove('open');
    document.body.classList.remove('side-cart-open');
    document.body.style.overflow = '';
    syncFormsTeaserVisibility();
    closeGiftModal();
  }

  function openGiftModal() {
    const modal = qs('[data-free-gift-modal]');
    if (!modal) return;
    modal.hidden = false;
    setLayerInert(modal, false);
  }

  function closeGiftModal() {
    const modal = qs('[data-free-gift-modal]');
    if (!modal) return;
    modal.hidden = true;
    setLayerInert(modal, true);
  }

  qsa('[data-cart-open]').forEach((b) => b.addEventListener('click', openCart));
  qsa('[data-cart-close], [data-cart-overlay]').forEach((b) => b.addEventListener('click', closeCart));
  qsa('[data-cart-added-close], [data-cart-added-continue]').forEach((b) =>
    b.addEventListener('click', closeCartAdded)
  );
  qsa('[data-cart-added-view]').forEach((b) =>
    b.addEventListener('click', () => {
      closeCartAdded();
      window.setTimeout(openCart, 380);
    })
  );
  if (cartAdded) {
    cartAdded.addEventListener('click', (e) => {
      if (e.target === cartAdded) closeCartAdded();
    });
  }

  qsa('.submenu-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const p = btn.closest('.nav-item');
      const o = p.classList.toggle('open');
      btn.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
  });

  const menuBtn = qs('[data-menu-toggle]');
  const mobile = qs('[data-mobile-menu]');
  const menuOverlay = qs('[data-mobile-menu-overlay]');

  function isMobileMenuOpen() {
    return mobile && mobile.classList.contains('open');
  }

  function closeMobileMenu() {
    if (!isMobileMenuOpen()) return;
    resetMobileMenuPanels();
    mobile.classList.remove('open');
    setLayerInert(mobile, true);
    if (menuOverlay) {
      menuOverlay.classList.remove('open');
      menuOverlay.setAttribute('aria-hidden', 'true');
    }
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-menu-open');
    const searchOpen = qs('[data-search-overlay]') && !qs('[data-search-overlay]').hidden;
    if (!document.body.classList.contains('side-cart-open') && !searchOpen) {
      document.body.style.overflow = '';
    }
    setFloatingWidgetsBelowMenu(false);
    syncFormsTeaserVisibility();
  }

  function setFloatingWidgetsBelowMenu(below) {
    qsa('shopify-forms-embed, #wwkSidebar, .phs-loyalty').forEach((el) => {
      if (!el) return;
      if (below) {
        if (el.dataset.phsMenuZ == null) el.dataset.phsMenuZ = el.style.zIndex || '';
        el.style.setProperty('z-index', '1', 'important');
      } else {
        if (el.dataset.phsMenuZ != null) {
          if (el.dataset.phsMenuZ) el.style.zIndex = el.dataset.phsMenuZ;
          else el.style.removeProperty('z-index');
          delete el.dataset.phsMenuZ;
        }
      }
    });
  }

  function openMobileMenu() {
    const searchOverlay = qs('[data-search-overlay]');
    if (searchOverlay && !searchOverlay.hidden) {
      searchOverlay.hidden = true;
      setLayerInert(searchOverlay, true);
      qsa('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }
    if (typeof closeCart === 'function') closeCart();
    closeExternalModals();
    mobile.classList.add('open');
    setLayerInert(mobile, false);
    if (menuOverlay) {
      menuOverlay.classList.add('open');
      menuOverlay.setAttribute('aria-hidden', 'false');
    }
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-menu-open');
    document.body.style.overflow = 'hidden';
    setFloatingWidgetsBelowMenu(true);
    resetMobileMenuPanels();
    const closeBtn = qs('[data-mobile-menu-close]', mobile);
    if (closeBtn) {
      requestAnimationFrame(() => closeBtn.focus({ preventScroll: true }));
    }
  }

  if (mobile) setLayerInert(mobile, !mobile.classList.contains('open'));

  if (menuBtn && mobile) {
    menuBtn.addEventListener('click', () => {
      if (isMobileMenuOpen()) closeMobileMenu();
      else openMobileMenu();
    });
    qsa('[data-mobile-menu-close], [data-mobile-menu-overlay]').forEach((el) => {
      el.addEventListener('click', closeMobileMenu);
    });
    qsa('[data-mobile-menu] a[href]').forEach((link) => {
      link.addEventListener('click', closeMobileMenu);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isMobileMenuOpen()) {
        e.stopPropagation();
        if (mobileMenuTrail.length > 1) {
          goMobileMenuBack();
        } else {
          closeMobileMenu();
          if (menuBtn) menuBtn.focus({ preventScroll: true });
        }
      }
    });
  }

  let mobileMenuTrail = ['root'];

  function clearMobileMenuInlineLayout() {
    const stack = qs('[data-mobile-menu-stack]', mobile);
    if (stack) {
      stack.style.width = '';
      stack.style.transform = '';
    }
    qsa('[data-mobile-panel]', mobile).forEach((panel) => {
      panel.style.width = '';
      panel.style.minWidth = '';
      panel.style.flex = '';
      panel.removeAttribute('inert');
    });
  }

  function applyMobileMenuTrail() {
    if (!mobile) return;
    clearMobileMenuInlineLayout();
    const current = mobileMenuTrail[mobileMenuTrail.length - 1] || 'root';
    const previous = mobileMenuTrail.length > 1 ? mobileMenuTrail[mobileMenuTrail.length - 2] : '';
    qsa('[data-mobile-panel]', mobile).forEach((panel) => {
      const handle = panel.dataset.mobilePanelHandle || 'root';
      const active = handle === current;
      panel.classList.toggle('is-active', active);
      panel.classList.toggle('is-left', !active && previous && handle === previous);
      panel.classList.toggle('is-right', !active && handle !== previous);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    qsa('[data-mobile-drill-handle]', mobile).forEach((btn) => {
      btn.setAttribute('aria-expanded', btn.getAttribute('data-mobile-drill-handle') === current ? 'true' : 'false');
    });
    const viewport = qs('.mobile-drawer__viewport', mobile);
    if (viewport) viewport.scrollLeft = 0;
    mobile.scrollLeft = 0;
    const activePanel = qs('[data-mobile-panel].is-active', mobile);
    if (current !== 'root' && activePanel) {
      const back = qs('[data-mobile-panel-back-to]', activePanel);
      if (back) requestAnimationFrame(() => back.focus({ preventScroll: true }));
    }
    requestAnimationFrame(() => {
      if (viewport) viewport.scrollLeft = 0;
      mobile.scrollLeft = 0;
    });
  }

  function resetMobileMenuPanels() {
    mobileMenuTrail = ['root'];
    applyMobileMenuTrail();
  }

  function openMobileDrill(handle) {
    if (!handle || !mobile) return;
    const panel = qs('[data-mobile-panel][data-mobile-panel-handle="' + CSS.escape(handle) + '"]', mobile);
    if (!panel) return;
    if (mobileMenuTrail[mobileMenuTrail.length - 1] === handle) return;
    mobileMenuTrail.push(handle);
    applyMobileMenuTrail();
  }

  function goMobileMenuBack() {
    if (mobileMenuTrail.length <= 1) return;
    mobileMenuTrail.pop();
    applyMobileMenuTrail();
  }

  if (mobile) {
    resetMobileMenuPanels();
    mobile.addEventListener('click', (e) => {
      const drillBtn = e.target.closest('[data-mobile-drill-handle]');
      if (drillBtn && mobile.contains(drillBtn)) {
        e.preventDefault();
        openMobileDrill(drillBtn.getAttribute('data-mobile-drill-handle'));
        return;
      }
      const backBtn = e.target.closest('[data-mobile-panel-back-to]');
      if (backBtn && mobile.contains(backBtn)) {
        e.preventDefault();
        goMobileMenuBack();
      }
    });
  }

  /* Search overlay: icon opens bar + autosuggest */
  (function initSearchOverlay() {
    const overlay = qs('[data-search-overlay]');
    const openBtns = qsa('[data-search-open]');
    if (!overlay || !openBtns.length) return;

    const input = qs('[data-search-input]', overlay) || qs('[data-predictive-input]', overlay);
    const panel = qs('[data-predictive-results]', overlay);
    setLayerInert(overlay, overlay.hidden);

    function closeMobileMenuForSearch() {
      if (typeof closeMobileMenu === 'function') closeMobileMenu();
    }

    function openSearch() {
      closeMobileMenuForSearch();
      overlay.hidden = false;
      setLayerInert(overlay, false);
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        if (!input) return;
        input.focus();
        if (input.value) input.select();
      });
    }

    function closeSearch() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      setLayerInert(overlay, true);
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (panel) {
        panel.hidden = true;
        panel.innerHTML = '';
      }
      if (input) input.setAttribute('aria-expanded', 'false');
      if (!qs('[data-side-cart].open')) document.body.style.overflow = '';
    }

    openBtns.forEach((b) => b.addEventListener('click', openSearch));
    qsa('[data-search-close]', overlay).forEach((b) => b.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) closeSearch();
    });
  })();

  /* Predictive search with image + price */
  (function initPredictiveSearch() {
    const roots = qsa('[data-predictive-search]');
    if (!roots.length) return;

    const moneyFmt = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        }).format(Number(cents) / 100);
      } catch (e) {
        return '€' + (Number(cents) / 100).toFixed(2).replace('.', ',');
      }
    };

    function productImage(product) {
      const img = product.featured_image || product.image || null;
      if (!img) return '';
      if (typeof img === 'string') return img;
      return img.url || img.src || '';
    }

    function productPrice(product) {
      const raw = product.price_min || product.price || (product.variants && product.variants[0] && product.variants[0].price) || 0;
      const str = String(raw);
      const euros = str.includes('.') ? Number(str) : Number(str) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        }).format(euros);
      } catch (e) {
        return '€' + euros.toFixed(2).replace('.', ',');
      }
    }

    roots.forEach((root) => {
      const form = root.matches('[data-predictive-form]') ? root : qs('[data-predictive-form]', root) || qs('form', root);
      const input = qs('[data-predictive-input]', root);
      const panel = qs('[data-predictive-results]', root);
      if (!form || !input || !panel) return;

      let timer = null;
      let controller = null;
      let active = -1;
      let items = [];

      function close() {
        panel.hidden = true;
        panel.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        root.classList.remove('is-open');
        active = -1;
        items = [];
      }

      function openPanel() {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        root.classList.add('is-open');
      }

      function setActive(next) {
        items.forEach((el, i) => el.classList.toggle('is-active', i === next));
        active = next;
      }

      function render(products, query) {
        if (!products.length) {
          panel.innerHTML = `<p class="predictive-search__empty">Geen producten voor “${query.replace(/[<>&"]/g, '')}”</p>`;
          openPanel();
          items = [];
          return;
        }

        const list = products.map((p, i) => {
          const img = productImage(p);
          const imgHtml = img
            ? `<div class="predictive-search__img"><img src="${img}" alt="${escapeAttr(p.title)}" width="52" height="52" loading="lazy"></div>`
            : `<div class="predictive-search__img"></div>`;
          const vendor = p.vendor ? `<p class="predictive-search__vendor">${p.vendor}</p>` : '';
          return `<a class="predictive-search__item" role="option" id="ps-opt-${i}" href="${p.url}">
            ${imgHtml}
            <div>
              <p class="predictive-search__title">${p.title}</p>
              ${vendor}
            </div>
            <span class="predictive-search__price">${productPrice(p)}</span>
          </a>`;
        }).join('');

        const allUrl = `${form.action}?q=${encodeURIComponent(query)}&type=product`;
        panel.innerHTML = `${list}<a class="predictive-search__footer" href="${allUrl}">Alle resultaten bekijken</a>`;
        items = qsa('.predictive-search__item', panel);
        openPanel();
        setActive(-1);
      }

      async function search(query) {
        if (controller) controller.abort();
        controller = new AbortController();
        panel.innerHTML = `<p class="predictive-search__status">Zoeken…</p>`;
        openPanel();
        try {
          const params = new URLSearchParams({
            q: query,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
          });
          const res = await fetch(`/search/suggest.json?${params.toString()}`, {
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });
          if (!res.ok) throw new Error('suggest failed');
          const data = await res.json();
          const products = (((data || {}).resources || {}).results || {}).products || [];
          render(products, query);
        } catch (err) {
          if (err.name === 'AbortError') return;
          panel.innerHTML = `<p class="predictive-search__empty">Zoeken lukte niet. Probeer opnieuw.</p>`;
          openPanel();
        }
      }

      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) {
          close();
          return;
        }
        timer = setTimeout(() => search(q), 220);
      });

      input.addEventListener('keydown', (e) => {
        if (panel.hidden || !items.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setActive(Math.min(items.length - 1, active + 1));
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setActive(Math.max(0, active - 1));
        } else if (e.key === 'Enter' && active >= 0) {
          e.preventDefault();
          items[active].click();
        } else if (e.key === 'Escape') {
          close();
          input.blur();
        }
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && panel.innerHTML) openPanel();
      });

      document.addEventListener('click', (e) => {
        if (!root.contains(e.target)) close();
      });
    });
  })();

  async function getCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function addItem(id, qty = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: Number(qty) })
    });
    const payload = await r.json();
    if (!r.ok) throw new Error('add failed');
    const cart = await getCart();
    updateCount(cart);
    await renderCart();
    openCart();
    try {
      if (window.phsMatomo && typeof window.phsMatomo.addToCart === 'function') {
        window.phsMatomo.addToCart(cart);
      }
    } catch (e) {}
  }

  async function changeItem(key, qty) {
    const nextQty = Number(qty);
    try {
      const current = await getCart();
      const giftIds = getFreeGiftIds();
      const line = (current.items || []).find((item) => item.key === key);
      if (line && giftIds.includes(Number(line.variant_id)) && nextQty > 1) {
        updateFreeGift(current);
        return;
      }
    } catch (e) {}
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: nextQty })
    });
    await renderCart();
  }

  function updateCount(cart) {
    const n = cart.item_count;
    qsa('[data-cart-count]').forEach((el) => (el.textContent = n));
    qsa('[data-cart-heading-count]').forEach((el) => (el.textContent = n));
    qsa('[data-cart-open]').forEach((btn) => btn.setAttribute('aria-label', cartButtonLabel(n)));
  }

  function updateMeter(cart) {
    const total = Number(cart.total_price || 0);
    const meters = qsa('[data-threshold-meter], [data-shipping-meter]');
    meters.forEach((meter) => {
      const threshold = Number(meter.dataset.threshold || 0);
      if (!threshold) return;
      const giftOn = meter.dataset.giftEnabled === 'true' || meter.dataset.gift === 'true';
      const msg =
        qs('[data-threshold-message]', meter) ||
        qs('[data-shipping-message]', meter);
      const bar =
        qs('[data-threshold-bar]', meter) ||
        qs('[data-shipping-bar]', meter);
      const left = Math.max(threshold - total, 0);
      const pct = Math.min(100, Math.round((total / threshold) * 100));
      if (bar) bar.style.width = pct + '%';
      if (!msg) return;
      if (left > 0) {
        const tpl = giftOn
          ? phsText('thresholdRemainingGift', 'Nog [amount] tot gratis verzending + MINI-cadeau')
          : phsText('thresholdRemaining', 'Nog [amount] tot gratis verzending');
        msg.innerHTML = phsAmount(tpl, '<strong>' + money(left) + '</strong>');
      } else {
        msg.textContent = giftOn
          ? phsText('thresholdUnlockedGift', 'Gratis verzending + MINI-cadeau ontgrendeld')
          : phsText('thresholdUnlocked', 'Je hebt gratis verzending bereikt');
      }
      meter.classList.toggle('is-unlocked', left <= 0);
    });
  }

  function getFreeGiftIds() {
    const box = qs('[data-free-gift]');
    if (!box) return [];
    const ids = qsa('[data-free-gift-option]', box)
      .map((b) => Number(b.dataset.variantId || 0))
      .filter(Boolean);
    const fallback = Number(box.dataset.variantId || 0);
    if (fallback && !ids.includes(fallback)) ids.push(fallback);
    return Array.from(new Set(ids));
  }

  function cartHasFreeGift(cart, giftIds = getFreeGiftIds()) {
    return giftIds.length
      ? (cart.items || []).some((item) => giftIds.includes(Number(item.variant_id)))
      : false;
  }

  async function cleanFreeGiftCart(cart) {
    const box = qs('[data-free-gift]');
    if (!box || box.dataset.enabled !== 'true') return cart;
    const threshold = Number(box.dataset.threshold || 4000);
    const giftIds = getFreeGiftIds();
    if (!threshold || !giftIds.length) return cart;
    const giftLines = (cart.items || []).filter((item) => giftIds.includes(Number(item.variant_id)));
    if (!giftLines.length) return cart;
    const shouldRemoveAll = Number(cart.total_price || 0) < threshold;
    const linesToRemove = shouldRemoveAll ? giftLines : giftLines.slice(1);
    if (!linesToRemove.length) return cart;
    await Promise.all(
      linesToRemove.map((line) =>
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        })
      )
    );
    return getCart();
  }

  function updateFreeGift(cart) {
    const box = qs('[data-free-gift]');
    if (!box) return;
    const enabled = box.dataset.enabled === 'true';
    const threshold = Number(box.dataset.threshold || 4000);
    const msg = qs('[data-free-gift-message]', box);
    const buttons = qsa('[data-free-gift-add]', box);
    const optionButtons = qsa('[data-free-gift-option]', box);
    const openButton = qs('[data-free-gift-open]', box);
    const giftIds = getFreeGiftIds();

    if (!enabled || !threshold) {
      box.hidden = true;
      return;
    }
    box.hidden = false;

    const total = Number(cart.total_price || 0);
    const eligible = total >= threshold;
    const hasAnyGift = cartHasFreeGift(cart, giftIds);
    const unconfigured = giftIds.length === 0;

    box.classList.toggle('is-eligible', eligible && !hasAnyGift && !unconfigured);
    box.classList.toggle('is-added', hasAnyGift);

    if (unconfigured) {
      if (msg) msg.textContent = 'Stel een cadeaucollectie of variant-ID in via de theme-instellingen.';
      buttons.forEach((btn) => (btn.disabled = true));
      if (openButton) openButton.hidden = true;
      closeGiftModal();
      return;
    }

    if (hasAnyGift) {
      if (msg) msg.textContent = phsText('giftInCart', 'Je gratis cadeau zit in je winkelwagen.');
      buttons.forEach((btn) => {
        btn.disabled = true;
        if (btn.classList.contains('free-gift-button')) btn.textContent = phsText('added', 'Toegevoegd');
      });
      optionButtons.forEach((btn) => btn.classList.add('is-disabled'));
      if (openButton) openButton.hidden = true;
      closeGiftModal();
      return;
    }

    const left = Math.max(threshold - total, 0);
    if (msg) {
      msg.textContent = eligible
        ? phsText('giftReady', 'Je gratis cadeau staat klaar. Kies er één.')
        : phsText('giftRemaining', 'Nog [amount] tot je gratis cadeau.').replace('[amount]', money(left));
    }
    if (openButton) {
      openButton.hidden = !eligible;
      openButton.disabled = !eligible;
    }
    if (!eligible) closeGiftModal();
    buttons.forEach((btn) => {
      const unavailable = btn.dataset.giftUnavailable === 'true';
      btn.disabled = !eligible || unavailable;
    });
    optionButtons.forEach((btn) => {
      const unavailable = btn.dataset.giftUnavailable === 'true';
      btn.disabled = !eligible || unavailable;
      btn.classList.toggle('is-disabled', !eligible || unavailable);
    });
  }

  async function renderCart() {
    if (!drawer) return;
    let cart = await getCart();
    cart = await cleanFreeGiftCart(cart);
    updateCount(cart);
    updateMeter(cart);
    updateFreeGift(cart);

    const items = qs('[data-cart-items]');
    const total = qs('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    if (!items) return;

    const itemsLabel = qs('[data-cart-items-label]', drawer);

    if (!cart.items.length) {
      if (itemsLabel) itemsLabel.hidden = true;
      items.innerHTML =
        '<div class="side-cart__empty"><h3>' +
        phsText('cartEmptyTitle', 'Je winkelwagen is nog leeg') +
        '</h3><p>' +
        phsText('cartEmptyTagline', 'Natuurlijke verzorging, persoonlijk geselecteerd.') +
        '</p><a class="btn btn--primary" href="/collections/all">' +
        phsText('cartEmptyCta', 'Shop bestsellers') +
        '</a></div>';
      updateCartUpsell(cart);
      return;
    }

    if (itemsLabel) itemsLabel.hidden = false;

    const giftIds = getFreeGiftIds();
    items.innerHTML = cart.items
      .map((item) => {
        const isGift = giftIds.includes(Number(item.variant_id));
        const qtyControls = isGift
          ? `<div class="pro-drawer-qty"><span>${item.quantity}</span></div>`
          : `<div class="pro-drawer-qty"><button type="button" aria-label="${escapeAttr(phsText('cartDecrease', 'Verlaag'))}" data-change="${item.key}" data-qty="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" aria-label="${escapeAttr(phsText('cartIncrease', 'Verhoog'))}" data-change="${item.key}" data-qty="${item.quantity + 1}">+</button></div>`;
        return `<div class="drawer-line${isGift ? ' is-free-gift-line' : ''}">
          <a href="${item.url}">${item.image ? `<img src="${item.image}" alt="${escapeAttr(item.product_title)}">` : ''}</a>
          <div>
            <a class="pro-line-title" href="${item.url}">${item.product_title}</a>
            ${isGift ? `<small class="pro-line-gift-label">${phsText('freeGiftLabel', 'Gratis cadeau')}</small>` : item.variant_title ? `<small>${item.variant_title}</small>` : ''}
            ${qtyControls}
          </div>
          <div class="pro-line-side">
            <strong>${money(item.final_line_price)}</strong>
            <button type="button" class="pro-remove" data-change="${item.key}" data-qty="0">${phsText('cartRemove', 'Verwijderen')}</button>
          </div>
        </div>`;
      })
      .join('');

    qsa('[data-change]', items).forEach((b) =>
      b.addEventListener('click', () => changeItem(b.dataset.change, b.dataset.qty))
    );

    updateCartUpsell(cart);
  }

  function submitSidecartCheckout(form, checkout) {
    // A disabled submit button is not part of the form data, so Shopify needs the checkout flag as a field.
    if (!form.querySelector('input[name="checkout"]')) {
      const flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'checkout';
      flag.value = '';
      form.appendChild(flag);
    }
    if (!checkout.dataset.label) checkout.dataset.label = checkout.textContent;
    checkout.disabled = true;
    checkout.textContent = 'Door naar afrekenen…';
    try {
      if (window.phsMatomo && typeof window.phsMatomo.checkout === 'function') {
        window.phsMatomo.checkout();
      }
    } catch (err) {}
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-checkout-button][data-label]').forEach((btn) => {
      btn.disabled = false;
      btn.textContent = btn.dataset.label;
    });
  });

  document.addEventListener(
    'touchend',
    (e) => {
      const checkout = e.target.closest('[data-checkout-button]');
      if (!checkout) return;
      const form = checkout.closest('[data-sidecart-checkout-form]');
      if (!form) return;
      e.preventDefault();
      submitSidecartCheckout(form, checkout);
    },
    { passive: false }
  );

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    try {
      await addItem(fd.get('id'), fd.get('quantity') || 1);
    } catch (err) {
      form.submit();
    }
  });

  document.addEventListener('click', async (e) => {
    const giftOpen = e.target.closest('[data-free-gift-open]');
    if (giftOpen) {
      e.preventDefault();
      if (!giftOpen.disabled) openGiftModal();
      return;
    }

    const giftClose = e.target.closest('[data-free-gift-close]');
    if (giftClose) {
      e.preventDefault();
      closeGiftModal();
      return;
    }

    const gift = e.target.closest('[data-free-gift-add]');
    if (gift) {
      e.preventDefault();
      const box = gift.closest('[data-free-gift]');
      const id = gift.dataset.variantId || (box ? box.dataset.variantId : null);
      if (!id || gift.disabled) return;
      gift.disabled = true;
      const oldText = gift.textContent;
      try {
        const current = await getCart();
        const giftIds = getFreeGiftIds();
        if (cartHasFreeGift(current, giftIds)) {
          await renderCart();
          return;
        }
        const threshold = Number(box?.dataset.threshold || 4000);
        if (Number(current.total_price || 0) < threshold) {
          updateFreeGift(current);
          gift.disabled = false;
          gift.textContent = oldText;
          return;
        }
        await addItem(id, 1);
        closeGiftModal();
      } catch (err) {
        gift.disabled = false;
        gift.textContent = oldText;
      }
      return;
    }

    const checkout = e.target.closest('[data-checkout-button]');
    if (checkout) {
      const form = checkout.closest('[data-sidecart-checkout-form]');
      if (form) {
        e.preventDefault();
        submitSidecartCheckout(form, checkout);
      }
      return;
    }

    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      await addItem(qa.dataset.variantId, 1);
    }

    const pm = e.target.closest('[data-qty-minus]');
    if (pm) {
      const inp = pm.parentElement.querySelector('input');
      inp.value = Math.max(1, Number(inp.value || 1) - 1);
    }
    const pp = e.target.closest('[data-qty-plus]');
    if (pp) {
      const inp = pp.parentElement.querySelector('input');
      inp.value = Number(inp.value || 1) + 1;
    }

    const stickyAdd = e.target.closest('[data-sticky-add]');
    if (stickyAdd) {
      e.preventDefault();
      const submit = document.querySelector('.product-form .add-to-cart');
      const form = document.querySelector('[data-product-form]');
      if (submit && !submit.disabled) submit.click();
      else if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeGiftModal();
      if (cartAdded && !cartAdded.hidden) closeCartAdded();
      else closeCart();
    }
  });

  qsa('[data-accordion] button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panelId = btn.getAttribute('aria-controls');
      const panel = (panelId && document.getElementById(panelId)) || btn.nextElementSibling;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-cart-line-change]');
    if (!a) return;
    e.preventDefault();
    a.style.pointerEvents = 'none';
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(a.dataset.line), quantity: Number(a.dataset.qty) })
      });
      window.location.reload();
    } catch (err) {
      window.location.href = a.href;
    }
  });

  /* Routine builder */
  qsa('[data-routine-builder]').forEach((builder) => {
    let need = 'hair-loss';
    let level = 'essential';
    const cards = qsa('[data-routine-card]', builder);
    const fallback = qs('[data-routine-fallback]', builder);

    function showMatch() {
      const match =
        cards.find((c) => c.dataset.need === need && c.dataset.level === level) ||
        cards.find((c) => c.dataset.need === need) ||
        cards[0];
      cards.forEach((c) => c.classList.add('hidden'));
      if (fallback) fallback.classList.add('hidden');
      if (match) match.classList.remove('hidden');
      else if (fallback) fallback.classList.remove('hidden');
    }

    qsa('[data-routine-need]', builder).forEach((btn) =>
      btn.addEventListener('click', () => {
        need = btn.dataset.routineNeed;
        qsa('[data-routine-need]', builder).forEach((b) => b.classList.toggle('is-active', b === btn));
        showMatch();
      })
    );
    qsa('[data-routine-level]', builder).forEach((btn) =>
      btn.addEventListener('click', () => {
        level = btn.dataset.routineLevel;
        qsa('[data-routine-level]', builder).forEach((b) => b.classList.toggle('is-active', b === btn));
        showMatch();
      })
    );
    qsa('[data-routine-add]', builder).forEach((btn) =>
      btn.addEventListener('click', async () => {
        const ids = (btn.dataset.variantIds || '')
          .split(',')
          .map((x) => x.trim())
          .filter(Boolean);
        if (!ids.length) {
          btn.textContent = 'Koppel eerst producten';
          btn.disabled = true;
          return;
        }
        btn.disabled = true;
        const old = btn.textContent;
        btn.textContent = 'Routine toevoegen…';
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
          });
          await renderCart();
          openCart();
          try {
            if (window.phsMatomo && typeof window.phsMatomo.addToCart === 'function') {
              window.phsMatomo.addToCart(await getCart());
            }
          } catch (e) {}
          btn.textContent = phsText('added', 'Toegevoegd');
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = old;
          }, 1400);
        } catch (err) {
          btn.disabled = false;
          btn.textContent = 'Probeer opnieuw';
        }
      })
    );
    showMatch();
  });

  /* Wishlist */
  const WISHLIST_KEY = 'phs_wishlist_v1';
  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    updateWishlistUI();
  }
  function isWishlisted(handle) {
    return readWishlist().some((i) => i.handle === handle);
  }
  function updateWishlistUI() {
    const items = readWishlist();
    qsa('[data-wishlist-count]').forEach((el) => {
      el.textContent = items.length;
      el.classList.toggle('is-zero', items.length === 0);
    });
    qsa('[data-wishlist-toggle]').forEach((btn) => {
      const saved = isWishlisted(btn.dataset.productHandle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', wishlistButtonLabel(saved, btn.dataset.productTitle));
      const label = btn.querySelector('span');
      if (label) {
        if (btn.classList.contains('wishlist-save')) {
          label.textContent = saved
            ? phsText('savedWishlist', 'Bewaard')
            : phsText('saveForLater', 'Bewaar voor later');
        } else {
          label.textContent = saved
            ? phsText('savedWishlist', 'Bewaard')
            : phsText('saveWishlist', 'Bewaar');
        }
      }
    });
    renderWishlistPage();
  }
  function toggleWishlist(btn) {
    const item = {
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice,
      variantId: btn.dataset.variantId
    };
    if (!item.handle) return;
    let items = readWishlist();
    if (items.some((i) => i.handle === item.handle)) {
      items = items.filter((i) => i.handle !== item.handle);
    } else {
      items.unshift(item);
    }
    writeWishlist(items.slice(0, 60));
  }
  function renderWishlistPage() {
    const grid = qs('[data-wishlist-grid]');
    if (!grid) return;
    const empty = qs('[data-wishlist-empty]');
    const items = readWishlist();
    if (empty) empty.classList.toggle('hidden', items.length > 0);
    grid.innerHTML = items
      .map(
        (item) => `<article class="product-card">
        <a class="product-card__media" href="${item.url || '#'}" tabindex="-1" aria-hidden="true">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
        <div class="product-card__info">
          <a href="${item.url || '#'}"><h3>${shortProductTitle(item.title || 'Product')}</h3></a>
          <div class="price-row"><strong>${item.price || ''}</strong></div>
          <div style="display:grid;gap:.5rem">
            ${item.variantId ? `<button class="btn btn--primary btn--buy btn--small" type="button" data-quick-add data-variant-id="${item.variantId}">In winkelwagen</button>` : ''}
            <button class="btn btn--ghost btn--small" type="button" data-wishlist-remove="${item.handle}">${phsText('cartRemove', 'Verwijderen')}</button>
          </div>
        </div>
      </article>`
      )
      .join('');
  }

  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-wishlist-toggle]');
    if (w) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(w);
      return;
    }
    const r = e.target.closest('[data-wishlist-remove]');
    if (r) {
      e.preventDefault();
      writeWishlist(readWishlist().filter((i) => i.handle !== r.dataset.wishlistRemove));
    }
  });

  updateWishlistUI();
  renderCart().catch(() => {});

  /* Product variant pills */
  function formatMoney(cents) {
    return money(Number(cents));
  }

  function getLoyaltyEarnPerEuro() {
    try {
      const rules = (window._ALConfig && window._ALConfig.pointEarnRules) || [];
      const purchase = rules.find((r) => r && r.type === 'PURCHASE' && r.status === 'ACTIVE');
      return Number(purchase && purchase.basePoints) || 10;
    } catch (e) {
      return 10;
    }
  }

  function syncProductLoyaltyEarn(priceCents, qty) {
    const el = qs('[data-product-loyalty-earn]');
    if (!el) return;
    const perEuro = getLoyaltyEarnPerEuro();
    const unit = Number(priceCents != null ? priceCents : el.dataset.priceCents) || 0;
    const amount = Math.max(1, Number(qty) || 1);
    if (priceCents != null) el.dataset.priceCents = String(unit);
    el.dataset.earnPerEuro = String(perEuro);
    const pts = Math.floor((unit / 100) * perEuro) * amount;
    const ptsEl = qs('[data-product-loyalty-earn-points]', el);
    if (ptsEl) ptsEl.textContent = new Intl.NumberFormat('nl-NL').format(pts);
    el.hidden = pts <= 0;
  }

  qsa('[data-product-form]').forEach((form) => {
    const picker = form.querySelector('[data-variant-picker]');
    const select = form.querySelector('[data-variant-select]');
    const qtyInput = form.querySelector('[name="quantity"], [data-qty-input]');

    /* Default-variant products: still refresh earn hint on qty */
    if (!picker || !select || select.tagName !== 'SELECT') {
      const refresh = () => {
        const earnEl = qs('[data-product-loyalty-earn]');
        const price = Number((earnEl && earnEl.dataset.priceCents) || 0);
        syncProductLoyaltyEarn(price, Math.max(1, Number(qtyInput && qtyInput.value) || 1));
      };
      form.addEventListener('change', (e) => {
        if (e.target.matches('[name="quantity"], [data-qty-input]')) refresh();
      });
      form.addEventListener('input', (e) => {
        if (e.target.matches('[name="quantity"], [data-qty-input]')) refresh();
      });
      refresh();
      return;
    }

    const priceEl = document.querySelector('[data-price]');
    const compareEl = document.querySelector('[data-compare-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const volumeEl = document.querySelector('[data-product-volume]');
    const addBtn = form.querySelector('[data-add-to-cart]');
    const wishlistBtn = form.querySelector('[data-wishlist-toggle]');

    function syncInciScore(barcode) {
      const root = qs('[data-inci-score]');
      if (!root) return;
      if (!barcode) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      root.href = `https://incibeauty.com/produit/${encodeURIComponent(barcode)}`;
      const img = root.querySelector('img');
      const tag = root.querySelector('ibscore');
      if (img) {
        try {
          const url = new URL(img.src);
          url.searchParams.set('ean', barcode);
          img.src = url.toString();
        } catch (err) {
          img.src = img.src.replace(/([?&]ean=)[^&]*/, `$1${encodeURIComponent(barcode)}`);
        }
        img.onload = () => { root.hidden = false; };
        img.onerror = () => { root.hidden = true; };
      } else if (tag) {
        tag.dataset.ean = barcode;
      }
    }

    function selectedOptions() {
      return [1, 2, 3].map((pos) => {
        const input = form.querySelector(`input[data-option-position="${pos}"]:checked`);
        return input ? input.value : null;
      });
    }

    function findVariant() {
      const [o1, o2, o3] = selectedOptions();
      return Array.from(select.options).find((opt) => {
        if (!opt.value) return false;
        const match1 = !o1 || opt.dataset.option1 === o1;
        const match2 = !o2 || opt.dataset.option2 === o2;
        const match3 = !o3 || opt.dataset.option3 === o3;
        return match1 && match2 && match3;
      });
    }

    function currentQty() {
      return Math.max(1, Number(qtyInput && qtyInput.value) || 1);
    }

    function syncVariant() {
      const opt = findVariant();
      if (!opt) return;
      select.value = opt.value;
      const available = opt.dataset.available === 'true';
      const price = Number(opt.dataset.price || 0);
      const compare = Number(opt.dataset.compare || 0);

      if (priceEl) priceEl.textContent = formatMoney(price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);
      if (volumeEl && opt.dataset.volume) volumeEl.textContent = opt.dataset.volume;
      if (compareEl) {
        if (compare > price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(compare);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available
          ? (phsText('addToCart', 'In winkelwagen') + ' — ' + formatMoney(price))
          : phsText('soldOut', 'Uitverkocht');
      }
      const stickyAdd = document.querySelector('[data-sticky-add]');
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.textContent = available ? phsText('addToCart', 'In winkelwagen') : phsText('soldOut', 'Uitverkocht');
      }
      if (wishlistBtn) {
        wishlistBtn.dataset.variantId = opt.value;
        wishlistBtn.dataset.productPrice = formatMoney(price);
      }

      qsa('.variant-pill', form).forEach((pill) => {
        const input = pill.querySelector('input');
        pill.classList.toggle('is-active', !!(input && input.checked));
      });

      syncProductLoyaltyEarn(price, currentQty());
      const loyaltyRoot = qs('[data-phs-loyalty]');
      if (loyaltyRoot) loyaltyRoot.dataset.productPrice = String(price);
      syncInciScore(opt.dataset.barcode || '');
    }

    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-position]')) syncVariant();
      if (e.target.matches('[name="quantity"], [data-qty-input]')) {
        const opt = findVariant();
        const price = Number((opt && opt.dataset.price) || 0);
        syncProductLoyaltyEarn(price, currentQty());
      }
    });
    form.addEventListener('input', (e) => {
      if (e.target.matches('[name="quantity"], [data-qty-input]')) {
        const opt = findVariant();
        const price = Number((opt && opt.dataset.price) || 0);
        syncProductLoyaltyEarn(price, currentQty());
      }
    });
    syncVariant();
  });

  /* Also refresh PDP earn hint when qty +/- buttons fire without change event timing */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const form = btn.closest('[data-product-form]');
    if (!form) return;
    window.setTimeout(() => {
      const select = form.querySelector('[data-variant-select]');
      const qtyInput = form.querySelector('[name="quantity"], [data-qty-input]');
      let price = 0;
      if (select && select.tagName === 'SELECT') {
        const opt = select.options[select.selectedIndex];
        price = Number((opt && opt.dataset.price) || 0);
      } else if (select) {
        const earnEl = qs('[data-product-loyalty-earn]');
        price = Number((earnEl && earnEl.dataset.priceCents) || 0);
      }
      syncProductLoyaltyEarn(price, Math.max(1, Number(qtyInput && qtyInput.value) || 1));
    }, 0);
  });

  /* Sticky ATC on mobile when main button leaves the viewport */
  (function initStickyBuy() {
    const sticky = qs('[data-sticky-buy]');
    const anchor = qs('[data-atc-anchor]');
    if (!sticky || !anchor) return;

    const sync = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      document.body.classList.toggle('sticky-atc-open', visible);
    };

    if (!('IntersectionObserver' in window)) {
      sync(true);
      return;
    }

    const io = new IntersectionObserver(
      ([entry]) => {
        const out = !entry.isIntersecting;
        sync(out);
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(anchor);
  })();

  /* Product image lightbox */
  (function initLightbox() {
    const gallery = qs('[data-product-gallery]');
    const dialog = qs('[data-lightbox]');
    const imgEl = qs('[data-lightbox-img]');
    if (!gallery || !dialog || !imgEl) return;

    const triggers = qsa('[data-lightbox-open]', gallery);
    if (!triggers.length) return;

    let index = 0;

    function largeSrc(img) {
      if (!img) return '';
      const srcset = img.getAttribute('srcset') || '';
      if (srcset) {
        const parts = srcset.split(',').map((p) => p.trim().split(/\s+/));
        const best = parts.reduce((acc, cur) => {
          const w = parseInt((cur[1] || '0').replace('w', ''), 10) || 0;
          return w >= (acc.w || 0) ? { w, url: cur[0] } : acc;
        }, { w: 0, url: '' });
        if (best.url) return best.url;
      }
      return img.currentSrc || img.src || '';
    }

    function show(i) {
      index = (i + triggers.length) % triggers.length;
      const trigger = triggers[index];
      const thumb = trigger.querySelector('img');
      imgEl.src = largeSrc(thumb);
      imgEl.alt = (thumb && thumb.alt) || '';
      const single = triggers.length < 2;
      qsa('[data-lightbox-prev], [data-lightbox-next]', dialog).forEach((btn) => {
        btn.hidden = single;
      });
    }

    function open(i) {
      show(i);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      if (!qs('[data-side-cart].open')) document.body.style.overflow = '';
    }

    triggers.forEach((btn, i) => {
      btn.addEventListener('click', () => open(i));
    });

    qsa('[data-lightbox-close]', dialog).forEach((b) => b.addEventListener('click', close));
    qs('[data-lightbox-prev]', dialog)?.addEventListener('click', (e) => {
      e.stopPropagation();
      show(index - 1);
    });
    qs('[data-lightbox-next]', dialog)?.addEventListener('click', (e) => {
      e.stopPropagation();
      show(index + 1);
    });

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) close();
    });

    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (!dialog.open) return;
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'Escape') close();
    });
  })();

  /* Mobile product gallery dots */
  (function initProductGalleryDots() {
    const gallery = qs('[data-product-gallery]');
    if (!gallery) return;
    const track = qs('[data-gallery-track]', gallery);
    const dots = qsa('[data-gallery-dots] .product-gallery__dot', gallery);
    const slides = qsa('.product-gallery__item', gallery);
    if (!track || dots.length < 2 || slides.length < 2) return;

    const setActive = (i) => {
      dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === i));
    };

    const updateFromScroll = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      slides.forEach((slide, i) => {
        const mid = slide.offsetLeft + slide.offsetWidth / 2;
        const dist = Math.abs(mid - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      setActive(best);
    };

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateFromScroll);
    }, { passive: true });
  })();

  /* Live product prices in article product cards (.article-product) */
  (function hydrateArticleProductPrices() {
    const cards = qsa('.article-product');
    if (!cards.length) return;

    const cache = new Map();
    const priceRe = /€\s*[\d.,]+/;

    function handleFromHref(href) {
      if (!href) return null;
      try {
        const path = new URL(href, window.location.origin).pathname;
        const m = path.match(/\/products\/([^/?#]+)/);
        return m ? decodeURIComponent(m[1]) : null;
      } catch (e) {
        return null;
      }
    }

    function loadProduct(handle) {
      if (cache.has(handle)) return cache.get(handle);
      const req = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
      cache.set(handle, req);
      return req;
    }

    function applyPrice(card, cents) {
      const formatted = money(Number(cents));
      const targets = qsa('[data-article-product-price]', card);
      if (targets.length) {
        targets.forEach((el) => {
          el.textContent = formatted;
        });
        return;
      }
      const meta = qs('.article-product__meta', card);
      if (!meta) return;
      const raw = meta.textContent || '';
      if (priceRe.test(raw)) {
        meta.textContent = raw.replace(priceRe, formatted);
      } else if (raw.trim()) {
        meta.textContent = formatted + ' · ' + raw.trim().replace(/^·\s*/, '');
      } else {
        meta.textContent = formatted;
      }
    }

    cards.forEach((card) => {
      const link = qs('a[href*="/products/"]', card);
      const handle = handleFromHref(link && link.getAttribute('href'));
      if (!handle) return;
      loadProduct(handle).then((product) => {
        if (!product || product.price == null) return;
        applyPrice(card, product.price);
      });
    });
  })();

  /* Shopify Forms: introductiekorting-tab links, halverwege, tekst op z'n zij */
  (function initFormsTeaserSideways() {
    const STYLE_ID = 'phs-forms-teaser-sideways';
    /* Shopify Forms gebruikt data-current-step="tease" (niet "teaser") */
    const css = `
      :host {
        --forms-accent-color: #8a6f4d !important;
        --forms-accent-color-hovered-modifier: rgba(138, 111, 77, 0.12) !important;
        --heading-text-color: #2f2a24 !important;
        --body-text-color: #3f3528 !important;
        --forms-heading-font: 600 0.92rem/1.2 ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif !important;
        --forms-body-font: 400 0.92rem/1.45 ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif !important;
      }

      /* Tease-stap: smalle verticale tab links midden */
      [data-current-step="tease"][data-layout="floating"],
      [data-layout="floating"][data-current-step="tease"],
      [data-current-step="teaser"][data-layout="floating"],
      [data-layout="floating"][data-current-step="teaser"] {
        left: 0 !important;
        right: unset !important;
        bottom: unset !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        rotate: unset !important;
        width: auto !important;
        max-width: none !important;
        padding: 0 !important;
        align-items: center !important;
        justify-content: start !important;
        pointer-events: none !important;
      }

      [data-current-step="tease"][data-layout="floating"] > div,
      [data-layout="floating"][data-current-step="tease"] > div,
      [data-current-step="teaser"][data-layout="floating"] > div,
      [data-layout="floating"][data-current-step="teaser"] > div {
        pointer-events: auto !important;
        rotate: unset !important;
        transform: none !important;
        transform-origin: center left !important;
        width: auto !important;
      }

      [data-current-step="tease"] button[data-testid="form-teaser"],
      [data-current-step="teaser"] button[data-testid="form-teaser"] {
        writing-mode: vertical-rl !important;
        text-orientation: mixed !important;
        display: inline-flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 0.45rem !important;
        margin: 0 !important;
        padding: 1rem 0.55rem !important;
        max-width: none !important;
        width: auto !important;
        border: 1px solid rgba(63, 53, 40, 0.12) !important;
        border-left: none !important;
        border-radius: 0 12px 12px 0 !important;
        background:
          radial-gradient(40px 90px at 0% 20%, rgba(138, 111, 77, 0.2), transparent 70%),
          #f3ebe1 !important;
        color: #2f2a24 !important;
        box-shadow: 6px 0 22px rgba(47, 42, 36, 0.12) !important;
        cursor: pointer !important;
        transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease !important;
      }

      [data-current-step="tease"] button[data-testid="form-teaser"]:hover,
      [data-current-step="teaser"] button[data-testid="form-teaser"]:hover {
        transform: translateX(3px) !important;
        box-shadow: 8px 0 26px rgba(47, 42, 36, 0.16) !important;
        background:
          radial-gradient(40px 90px at 0% 20%, rgba(138, 111, 77, 0.28), transparent 70%),
          #efe4d6 !important;
      }

      [data-current-step="tease"] button[data-testid="form-teaser"] h3,
      [data-current-step="teaser"] button[data-testid="form-teaser"] h3,
      [data-current-step="tease"] [class*="teaserHeading"],
      [data-current-step="teaser"] [class*="teaserHeading"] {
        margin: 0 !important;
        font: 600 0.88rem/1.15 ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif !important;
        letter-spacing: 0.04em !important;
        color: #2f2a24 !important;
        white-space: nowrap !important;
      }

      /* Sluit-kruis kleiner en rustiger op de tab */
      [data-current-step="tease"] [class*="formCloseButton"],
      [data-current-step="teaser"] [class*="formCloseButton"] {
        width: 0.95rem !important;
        height: 0.95rem !important;
        opacity: 0.5 !important;
        flex-shrink: 0 !important;
        transform: rotate(90deg) !important;
      }
      [data-current-step="tease"] [class*="formCloseButton"]:hover,
      [data-current-step="teaser"] [class*="formCloseButton"]:hover {
        opacity: 0.9 !important;
      }

      @media (max-width: 749px) {
        [data-current-step="tease"] button[data-testid="form-teaser"],
        [data-current-step="teaser"] button[data-testid="form-teaser"] {
          padding: 0.8rem 0.45rem !important;
        }
        [data-current-step="tease"] button[data-testid="form-teaser"] h3,
        [data-current-step="teaser"] button[data-testid="form-teaser"] h3,
        [data-current-step="tease"] [class*="teaserHeading"],
        [data-current-step="teaser"] [class*="teaserHeading"] {
          font-size: 0.78rem !important;
        }
      }

      /* Open formulier: volledig in beeld (niet half afgesneden door tease-positie) */
      [data-current-step="form"][data-layout="floating"],
      [data-layout="floating"][data-current-step="form"],
      [data-current-step="success"][data-layout="floating"],
      [data-layout="floating"][data-current-step="success"] {
        left: 50% !important;
        right: unset !important;
        top: 50% !important;
        bottom: unset !important;
        transform: translate(-50%, -50%) !important;
        rotate: unset !important;
        width: min(100vw - 1.5rem, 22rem) !important;
        max-width: calc(100vw - 1.5rem) !important;
        max-height: min(90vh, 40rem) !important;
        padding: 0 !important;
        overflow: auto !important;
        align-items: center !important;
        justify-content: center !important;
        pointer-events: auto !important;
      }

      [data-current-step="form"][data-layout="floating"] > div,
      [data-layout="floating"][data-current-step="form"] > div,
      [data-current-step="success"][data-layout="floating"] > div,
      [data-layout="floating"][data-current-step="success"] > div {
        rotate: unset !important;
        transform: none !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 auto !important;
      }
    `;

    function clearForcedPosition(el) {
      ['left', 'right', 'top', 'bottom', 'transform', 'rotate', 'padding', 'width', 'max-width'].forEach((prop) => {
        el.style.removeProperty(prop);
      });
    }

    function positionFormsTease(tease) {
      if (!tease) return;
      tease.setAttribute('data-position', 'left-middle-rotated');
      tease.style.setProperty('left', '0', 'important');
      tease.style.setProperty('right', 'unset', 'important');
      tease.style.setProperty('bottom', 'unset', 'important');
      tease.style.setProperty('top', '50%', 'important');
      tease.style.setProperty('transform', 'translateY(-50%)', 'important');
      tease.style.setProperty('rotate', 'unset', 'important');
      tease.style.setProperty('padding', '0', 'important');
      tease.style.removeProperty('width');
      tease.style.removeProperty('max-width');
    }

    function inject(root) {
      if (!root) return;
      let style = root.getElementById(STYLE_ID);
      if (!style) {
        style = document.createElement('style');
        style.id = STYLE_ID;
        root.appendChild(style);
      }
      style.textContent = css;

      const tease = root.querySelector('[data-current-step="tease"], [data-current-step="teaser"]');
      const openForm = root.querySelector('[data-current-step="form"], [data-current-step="success"]');

      if (tease) {
        positionFormsTease(tease);
      }

      if (openForm) {
        /* Tease-inline-styles blijven anders op hetzelfde element hangen → half buiten beeld */
        clearForcedPosition(openForm);
        openForm.setAttribute('data-position', 'center');
        openForm.style.setProperty('left', '50%', 'important');
        openForm.style.setProperty('right', 'unset', 'important');
        openForm.style.setProperty('top', '50%', 'important');
        openForm.style.setProperty('bottom', 'unset', 'important');
        openForm.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
        openForm.style.setProperty('rotate', 'unset', 'important');
        openForm.style.setProperty('padding', '0', 'important');
        openForm.style.setProperty('width', 'min(100vw - 1.5rem, 22rem)', 'important');
        openForm.style.setProperty('max-width', 'calc(100vw - 1.5rem)', 'important');
      }
    }

    function scan() {
      qsa('shopify-forms-embed').forEach((host) => inject(host.shadowRoot));
      syncFormsTeaserVisibility();
    }

    scan();
    const obs = new MutationObserver(scan);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scan);
  })();

  /* Custom PHS loyalty widget (Appstle backend) */
  (function initPhsLoyalty() {
    const root = qs('[data-phs-loyalty]');
    if (!root) return;

    const panel = qs('[data-phs-loyalty-panel]', root);
    const backdrop = qs('.phs-loyalty__backdrop', root);
    if (panel) setLayerInert(panel, !root.classList.contains('is-open'));
    const closeBtns = qsa('[data-phs-loyalty-close]', root);
    const pointsEl = qs('[data-phs-loyalty-points]', root);
    const worthEl = qs('[data-phs-loyalty-worth]', root);
    const launcherPts = qs('[data-phs-loyalty-launcher-points]', root);
    const balanceBlock = qs('[data-phs-loyalty-balance-block]', root);
    const guestEl = qs('[data-phs-loyalty-guest]', root);
    const memberEl = qs('[data-phs-loyalty-member]', root);
    const redeemWrap = qs('[data-phs-loyalty-redeem]', root);
    const redeemPtsEl = qs('[data-phs-loyalty-redeem-points]', root);
    const redeemEuroEl = qs('[data-phs-loyalty-redeem-euro]', root);
    const redeemBtn = qs('[data-phs-loyalty-redeem-btn]', root);
    const minusBtn = qs('[data-phs-loyalty-minus]', root);
    const plusBtn = qs('[data-phs-loyalty-plus]', root);
    const statusEl = qs('[data-phs-loyalty-status]', root);
    const earnHint = qs('[data-phs-loyalty-earn-hint]', root);
    const rewardWrap = qs('[data-phs-loyalty-reward]', root);
    const codeEl = qs('[data-phs-loyalty-code]', root);
    const applyBtn = qs('[data-phs-loyalty-apply]', root);
    const cartStrip = qs('[data-phs-loyalty-cart-strip]');
    const cartPts = qs('[data-phs-loyalty-cart-points]');
    const cartWorth = qs('[data-phs-loyalty-cart-worth]');

    let redeemPoints = 100;
    let lastDiscountCode = '';
    let availablePoints = 0;

    const openBtns = () => qsa('[data-phs-loyalty-open]');

    function fmt(n) {
      return new Intl.NumberFormat('nl-NL').format(Math.max(0, Math.floor(Number(n) || 0)));
    }

    function euroFromPoints(pts, redeemRule) {
      const per = Number(redeemRule && redeemRule.redeemPoints) || 100;
      const disc = Number(redeemRule && redeemRule.discount) || 1;
      return Math.floor(pts / per) * disc;
    }

    function moneyEuro(amount) {
      try {
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(amount);
      } catch (e) {
        return '€' + Number(amount).toFixed(2).replace('.', ',');
      }
    }

    function getConfig() {
      return window._ALConfig || {};
    }

    function getRedeemRule() {
      const rules = getConfig().pointRedeemRules || [];
      return rules.find((r) => r && r.status === 'ACTIVE') || rules[0] || null;
    }

    function getEarnPerEuro() {
      const rules = getConfig().pointEarnRules || [];
      const purchase = rules.find((r) => r && r.type === 'PURCHASE' && r.status === 'ACTIVE');
      return Number(purchase && purchase.basePoints) || 10;
    }

    function proxyPath() {
      return String(getConfig().proxy_path_prefix || 'apps/loyalty').replace(/^\/+|\/+$/g, '');
    }

    function setStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.classList.toggle('is-error', kind === 'error');
      statusEl.classList.toggle('is-ok', kind === 'ok');
    }

    function syncRedeemUI(rule) {
      const step = Number(rule && rule.redeemPoints) || 100;
      const disc = Number(rule && rule.discount) || 1;
      const maxMultiples = Math.floor(availablePoints / step);
      if (redeemPoints < step) redeemPoints = step;
      if (maxMultiples > 0 && redeemPoints > maxMultiples * step) {
        redeemPoints = maxMultiples * step;
      }
      const euros = (redeemPoints / step) * disc;
      if (redeemPtsEl) redeemPtsEl.textContent = fmt(redeemPoints);
      if (redeemEuroEl) redeemEuroEl.textContent = '= ' + moneyEuro(euros);
      if (minusBtn) minusBtn.disabled = redeemPoints <= step || availablePoints < step;
      if (plusBtn) plusBtn.disabled = redeemPoints + step > availablePoints;
      if (redeemBtn) {
        redeemBtn.disabled = availablePoints < step;
        redeemBtn.textContent = availablePoints < step
          ? phsText('loyaltyNotEnough', 'Nog niet genoeg punten')
          : phsText('redeemFor', 'Inwisselen voor ') + moneyEuro(euros);
      }
    }

    function render() {
      const cfg = getConfig();
      const loggedIn = root.dataset.loggedIn === 'true' || !!cfg.customerId;
      const loyalty = cfg.customerLoyalty || null;
      const rule = getRedeemRule();
      const step = Number(rule && rule.redeemPoints) || 100;

      availablePoints = Number(loyalty && loyalty.availablePoints) || 0;
      if (redeemPoints % step !== 0) redeemPoints = step;

      if (guestEl) guestEl.hidden = loggedIn;
      if (memberEl) memberEl.hidden = !loggedIn;

      if (loggedIn) {
        if (balanceBlock) balanceBlock.hidden = false;
        if (pointsEl) pointsEl.textContent = fmt(availablePoints);
        const worth = euroFromPoints(availablePoints, rule);
        if (worthEl) {
          worthEl.textContent = availablePoints > 0
            ? 'Goed voor ' + moneyEuro(worth) + ' korting'
            : 'Spaar bij je volgende bestelling';
        }
        if (launcherPts) {
          launcherPts.hidden = false;
          launcherPts.classList.toggle('is-empty', availablePoints <= 0);
          launcherPts.textContent = fmt(availablePoints);
        }
        if (redeemWrap) redeemWrap.hidden = false;
        syncRedeemUI(rule);

        if (cartStrip) {
          cartStrip.hidden = false;
          if (cartPts) cartPts.textContent = fmt(availablePoints) + ' punten';
          if (cartWorth) {
            cartWorth.textContent = availablePoints > 0
              ? '= ' + moneyEuro(worth) + ' korting'
              : 'Begin met sparen';
          }
        }
      } else {
        if (balanceBlock) balanceBlock.hidden = true;
        if (launcherPts) {
          launcherPts.hidden = true;
          launcherPts.classList.add('is-empty');
        }
        if (cartStrip) cartStrip.hidden = true;
      }

      if (earnHint) {
        const cents = Number(root.dataset.productPrice || 0);
        const perEuro = getEarnPerEuro();
        if (cents > 0 && perEuro > 0) {
          const pts = Math.floor((cents / 100) * perEuro);
          earnHint.hidden = false;
          earnHint.textContent = (loggedIn
            ? phsText('loyaltyEarnIn', 'Spaar [points] punten met dit product')
            : phsText('loyaltyEarnOut', 'Leden sparen [points] punten met dit product')
          ).replace('[points]', fmt(pts));
        } else {
          earnHint.hidden = true;
        }
      }

      const pdpEarn = qs('[data-product-loyalty-earn]');
      if (pdpEarn && typeof syncProductLoyaltyEarn === 'function') {
        const qtyInput = qs('[data-product-form] [name="quantity"], [data-product-form] [data-qty-input]');
        syncProductLoyaltyEarn(
          Number(root.dataset.productPrice || pdpEarn.dataset.priceCents || 0),
          Math.max(1, Number(qtyInput && qtyInput.value) || 1)
        );
      }
    }

    function openPanel() {
      if (document.body.classList.contains('side-cart-open')) closeCart();
      root.classList.add('is-open');
      if (panel) {
        panel.hidden = false;
        setLayerInert(panel, false);
      }
      if (backdrop) backdrop.hidden = false;
      openBtns().forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.style.overflow = 'hidden';
      const closeBtn = qs('.phs-loyalty__close', root);
      if (closeBtn) closeBtn.focus();
      render();
    }

    function closePanel() {
      root.classList.remove('is-open');
      if (panel) {
        setLayerInert(panel, true);
        window.setTimeout(() => {
          if (!root.classList.contains('is-open')) panel.hidden = true;
        }, 280);
      }
      if (backdrop) backdrop.hidden = true;
      openBtns().forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (!qs('[data-side-cart].open')) document.body.style.overflow = '';
    }

    async function applyDiscount(code) {
      if (!code) return false;
      try {
        const res = await fetch('/discount/' + encodeURIComponent(String(code).trim()), {
          credentials: 'same-origin'
        });
        return res.ok;
      } catch (e) {
        return false;
      }
    }

    async function redeem() {
      const cfg = getConfig();
      const rule = getRedeemRule();
      if (!rule || !cfg.customerId) {
        setStatus('Log in om punten in te wisselen.', 'error');
        return;
      }
      const step = Number(rule.redeemPoints) || 100;
      if (availablePoints < step) {
        setStatus('Je hebt nog niet genoeg punten.', 'error');
        return;
      }

      redeemBtn.disabled = true;
      setStatus('Bezig met inwisselen…');

      const body = {
        redeemRuleId: rule.id,
        points: redeemPoints,
        customerId: Number(cfg.customerId)
      };

      try {
        const res = await fetch('/' + proxyPath() + '/cp/api/redeem-points', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json().catch(() => null);
        if (!res.ok) {
          const err = (data && (data.error || data.message)) || 'Inwisselen mislukt. Probeer het opnieuw.';
          setStatus(String(err), 'error');
          redeemBtn.disabled = false;
          return;
        }

        if (data && typeof data.availablePoints === 'number') {
          cfg.customerLoyalty = Object.assign({}, cfg.customerLoyalty || {}, data);
          availablePoints = Number(data.availablePoints) || 0;
        } else if (cfg.customerLoyalty) {
          cfg.customerLoyalty.availablePoints = Math.max(0, availablePoints - redeemPoints);
        }

        const rewards = (data && data.rewards) || (cfg.customerLoyalty && cfg.customerLoyalty.rewards) || [];
        const unused = rewards.filter((r) => r && r.status === 'UNUSED' && r.discountCode);
        const newest = unused.length ? unused[unused.length - 1] : null;
        lastDiscountCode = (newest && newest.discountCode) || '';

        if (lastDiscountCode) {
          if (rewardWrap) rewardWrap.hidden = false;
          if (codeEl) codeEl.textContent = lastDiscountCode;
          const applied = await applyDiscount(lastDiscountCode);
          setStatus(
            applied
              ? phsText('discountApplied', 'Korting toegepast op je winkelwagen.')
              : 'Code aangemaakt — klik op Toepassen.',
            applied ? 'ok' : 'error'
          );
        } else {
          setStatus('Punten ingewisseld.', 'ok');
        }
        render();
      } catch (e) {
        setStatus('Er ging iets mis. Probeer het later opnieuw.', 'error');
      } finally {
        redeemBtn.disabled = false;
        syncRedeemUI(getRedeemRule());
      }
    }

    openBtns().forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (root.classList.contains('is-open')) closePanel();
        else openPanel();
      });
    });
    closeBtns.forEach((btn) => btn.addEventListener('click', closePanel));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closePanel();
    });

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        const step = Number((getRedeemRule() || {}).redeemPoints) || 100;
        redeemPoints = Math.max(step, redeemPoints - step);
        syncRedeemUI(getRedeemRule());
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        const step = Number((getRedeemRule() || {}).redeemPoints) || 100;
        if (redeemPoints + step <= availablePoints) redeemPoints += step;
        syncRedeemUI(getRedeemRule());
      });
    }
    if (redeemBtn) redeemBtn.addEventListener('click', redeem);
    if (applyBtn) {
      applyBtn.addEventListener('click', async () => {
        const code = lastDiscountCode || (codeEl && codeEl.textContent) || '';
        const ok = await applyDiscount(code);
        setStatus(ok ? 'Korting toegepast.' : 'Kon code niet toepassen.', ok ? 'ok' : 'error');
      });
    }

    render();
    let tries = 0;
    const poll = window.setInterval(() => {
      tries += 1;
      if (window._ALConfig || tries > 40) {
        window.clearInterval(poll);
        render();
      }
    }, 250);

    document.addEventListener('shopify:section:load', render);
  })();

  function updateCartUpsell(cart) {
    const box = qs('[data-cart-upsell]');
    if (!box) return;
    const threshold = Number(box.dataset.threshold || 4000);
    const total = Number((cart && cart.total_price) || 0);
    const giftIds = getFreeGiftIds();
    const productIds = new Set(
      ((cart && cart.items) || [])
        .filter((item) => !giftIds.includes(Number(item.variant_id)))
        .map((item) => Number(item.product_id))
    );
    let visible = 0;
    qsa('[data-cart-upsell-item]', box).forEach((row) => {
      const inCart = productIds.has(Number(row.dataset.productId));
      const hide = inCart || !((cart && cart.items) || []).length || total >= threshold;
      row.hidden = hide;
      if (!hide) visible += 1;
    });
    const textEl = qs('[data-cart-upsell-text]', box);
    if (textEl) {
      const remaining = Math.max(0, threshold - total);
      textEl.textContent =
        remaining > 0
          ? phsText('upsellRemaining', 'Nog [amount] tot gratis verzending + MINI — voeg iets toe.').replace('[amount]', money(remaining))
          : phsText('upsellUnlocked', 'Drempel gehaald — kies hieronder je cadeau.');
    }
    box.hidden = !(cart && cart.items && cart.items.length && total < threshold && visible > 0);
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      this.load();
    }

    async load() {
      const productId = this.dataset.productId;
      const limit = Number(this.dataset.limit || 4);
      const intent = this.dataset.intent || 'related';
      const exclude = String(this.dataset.exclude || '');
      const grid = this.querySelector('[data-recs-grid]');
      if (!productId || !grid) return;

      try {
        let products = await this.fetchRecs(productId, limit + 4, intent);
        products = products.filter((p) => String(p.id) !== exclude);
        if (!products.length && intent === 'complementary') {
          products = (await this.fetchRecs(productId, limit + 4, 'related')).filter(
            (p) => String(p.id) !== exclude
          );
        }
        products = products.slice(0, limit);
        if (!products.length) return;
        grid.innerHTML = products.map((p) => this.cardHtml(p)).join('');
        qsa('[data-reveal]', grid).forEach((el) => el.classList.add('is-in'));
      } catch (err) {
        /* keep liquid bestsellers fallback */
      }
    }

    async fetchRecs(productId, limit, intent) {
      const url = `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=${limit}&intent=${encodeURIComponent(intent)}`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return [];
      const data = await res.json();
      return data.products || [];
    }

    cardHtml(p) {
      const display = shortProductTitle(p.title || 'Product', 0);
      const title = display
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;');
      const alt = String(p.title || display)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;');
      let vendorRaw = String(p.vendor || '');
      if (vendorRaw === 'Pure Health Store' && /Evergetikon/.test(p.title || '')) vendorRaw = 'Evergetikon';
      const vendor = vendorRaw.replace(/&/g, '&amp;').replace(/</g, '&lt;');
      const parts = title.split(' - ').map((s) => s.trim()).filter((s) => s && s !== vendor);
      let mainTitle = parts[0] || title;
      let rest = parts.slice(1).join(' - ');
      if (rest && parts.length === 2 && rest.length <= 18) {
        mainTitle = `${mainTitle} ${rest}`;
        rest = '';
      }
      const subTitle = rest ? rest.charAt(0).toUpperCase() + rest.slice(1) : '';
      const href = p.url || `/products/${p.handle}`;
      const img = p.featured_image || (p.images && p.images[0]) || '';
      const src = img ? (String(img).startsWith('//') || String(img).startsWith('http') ? img : `//${img}`) : '';
      const sized = src ? `${src}${src.includes('?') ? '&' : '?'}width=600` : '';
      const variants = p.variants || [];
      const onlyDefault = variants.length <= 1;
      const available = variants.some((v) => v.available) || p.available;
      const variant = variants.find((v) => v.available) || variants[0];
      const priceCents = Number(
        p.price_min != null ? p.price_min : p.price || (variant && variant.price) || 0
      );
      const action =
        onlyDefault && available && variant
          ? `<button class="btn btn--primary btn--buy btn--small btn--full" type="button" data-quick-add data-variant-id="${variant.id}" aria-label="${phsText('addToCart', 'In winkelwagen')}"><span class="product-card__quick-label">${phsText('addToCart', 'In winkelwagen')}</span></button>`
          : `<a class="btn btn--primary btn--small btn--full" href="${href}" aria-label="${phsText('chooseOptions', 'Opties kiezen')}"><span class="product-card__quick-label">${phsText('chooseOptions', 'Opties kiezen')}</span></a>`;
      return `<article class="product-card is-in" data-reveal>
        <div class="product-card__media">
          <a href="${href}" tabindex="-1" aria-hidden="true">${sized ? `<img src="${sized}" alt="" loading="lazy" width="600" height="750">` : `<div class="image-placeholder">${title}</div>`}</a>
          <div class="product-card__actions">${action}</div>
        </div>
        <div class="product-card__info">
          ${vendor ? `<p class="product-card__vendor">${vendor}</p>` : ''}
          <h3 class="product-card__title"><a href="${href}">${mainTitle}</a></h3>
          ${subTitle ? `<p class="product-card__sub">${subTitle}</p>` : ''}
          <div class="price-row"><strong>${p.price_varies ? `${String(phsText('productFrom', 'Vanaf')).trim()} ` : ''}${money(priceCents)}</strong></div>
        </div>
      </article>`;
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  qsa('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  function initFacets(form) {
    const sectionId = form.dataset.sectionId;
    const section = form.closest('.collection-page') || document;
    const panel = qs('[data-facets-panel]', form);
    const overlay = qs('.facets__overlay', form);
    const openBtn = qs('[data-facets-open]', form);
    const desktop = window.matchMedia('(min-width: 750px)');
    let controller = null;
    let priceTimer = null;
    const cache = new Map();

    const isDrawerOpen = () => form.classList.contains('is-drawer-open');
    const facets = () => qsa('[data-facet]', form);

    function urlFromForm() {
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => {
        if (String(value).trim() !== '') params.append(key, value);
      });
      const url = new URL(form.action || window.location.pathname, window.location.origin);
      url.search = params.toString();
      return url;
    }

    function syncFrom(doc, syncChecked) {
      const nextForm = qs('[data-facets]', doc);
      const nextResults = qs('[data-collection-results]', doc);
      const results = qs('[data-collection-results]', section);
      if (!nextForm || !nextResults || !results) return false;

      const cur = qsa('[data-facets-sync]', form);
      const next = qsa('[data-facets-sync]', nextForm);
      if (cur.length !== next.length) return false;
      cur.forEach((el, i) => {
        el.innerHTML = next[i].innerHTML;
        el.hidden = next[i].hidden;
        if (next[i].hasAttribute('href')) el.setAttribute('href', next[i].getAttribute('href'));
      });

      qsa('[data-facet-input]', form).forEach((input) => {
        const twin = nextForm.querySelector('#' + CSS.escape(input.id));
        if (!twin) return;
        input.disabled = twin.disabled;
        if (syncChecked) {
          if (input.type === 'checkbox') input.checked = twin.checked;
          else input.value = twin.value;
        }
        const label = input.closest('.facet__option');
        if (label) label.classList.toggle('is-disabled', twin.disabled);
      });
      if (syncChecked) {
        const sort = qs('[data-facets-sort]', form);
        const nextSort = qs('[data-facets-sort]', nextForm);
        if (sort && nextSort) sort.value = nextSort.value;
      }

      results.replaceWith(nextResults);
      qsa('[data-reveal]', nextResults).forEach((el) => el.classList.add('is-in'));
      updateWishlistUI();
      return true;
    }

    async function render(url, { push = true, syncChecked = false } = {}) {
      const pageUrl = new URL(url, window.location.origin);
      pageUrl.searchParams.delete('section_id');
      pageUrl.searchParams.delete('page');
      const key = pageUrl.search;
      const fetchUrl = new URL(pageUrl);
      fetchUrl.searchParams.set('section_id', sectionId);

      if (controller) controller.abort();
      controller = new AbortController();
      form.classList.add('is-loading');
      try {
        let html = cache.get(key);
        if (!html) {
          const res = await fetch(fetchUrl, { signal: controller.signal, headers: { Accept: 'text/html' } });
          if (!res.ok) throw new Error('HTTP ' + res.status);
          html = await res.text();
          cache.set(key, html);
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!syncFrom(doc, syncChecked)) {
          window.location.assign(pageUrl.toString());
          return;
        }
        if (push && pageUrl.toString() !== window.location.href) {
          history.pushState({ facets: true }, '', pageUrl.toString());
        }
      } catch (err) {
        if (err.name !== 'AbortError') window.location.assign(pageUrl.toString());
      } finally {
        form.classList.remove('is-loading');
      }
    }

    function scrollToResults() {
      const top = form.getBoundingClientRect().top + window.scrollY - 90;
      if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
    }

    function openDrawer() {
      if (!panel) return;
      facets().forEach((d) => { d.open = true; });
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      overlay.hidden = false;
      requestAnimationFrame(() => form.classList.add('is-drawer-open'));
      openBtn?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(() => qs('.facets__panel-close', panel)?.focus(), 50);
    }

    function closeDrawer({ restoreFocus = true } = {}) {
      if (!isDrawerOpen()) return;
      form.classList.remove('is-drawer-open');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      openBtn?.setAttribute('aria-expanded', 'false');
      if (!qs('[data-side-cart].open')) document.body.style.overflow = '';
      setTimeout(() => {
        if (isDrawerOpen()) return;
        overlay.hidden = true;
        facets().forEach((d) => { d.open = false; });
      }, 300);
      if (restoreFocus) openBtn?.focus();
    }

    openBtn?.addEventListener('click', openDrawer);
    qsa('[data-facets-close]', form).forEach((el) => el.addEventListener('click', () => closeDrawer()));

    form.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-facet-price]')) {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(() => render(urlFromForm()), 500);
        return;
      }
      if (t.matches('[data-facet-input], [data-facets-sort]')) render(urlFromForm());
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      clearTimeout(priceTimer);
      const url = urlFromForm();
      const done = () => { closeDrawer(); scrollToResults(); };
      if (url.search === window.location.search) done();
      else render(url).then(done);
    });

    section.addEventListener('click', (e) => {
      const link = e.target.closest('[data-facets-link]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      render(link.href, { syncChecked: true });
    });

    facets().forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!d.open || !desktop.matches) return;
        facets().forEach((other) => { if (other !== d) other.open = false; });
      });
    });

    document.addEventListener('click', (e) => {
      if (!desktop.matches) return;
      facets().forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (isDrawerOpen()) { closeDrawer(); return; }
      const open = facets().find((d) => d.open);
      if (open && desktop.matches) {
        open.open = false;
        qs('summary', open)?.focus();
      }
    });

    desktop.addEventListener('change', () => {
      closeDrawer({ restoreFocus: false });
      facets().forEach((d) => { d.open = false; });
    });

    window.addEventListener('popstate', () => {
      render(window.location.href, { push: false, syncChecked: true });
    });
  }

  const facetsForm = qs('[data-facets]');
  if (facetsForm && facetsForm.dataset.sectionId) initFacets(facetsForm);

  function localizeFormUi(root) {
    const strings = {
      heading: phsText('formHeading', '10% Korting op je eerste bestelling?'),
      body: phsText('formBody', 'Schrijf je in en ontvang de beste tips en exclusieve aanbiedingen.'),
      firstName: phsText('formFirstName', 'Voornaam'),
      email: phsText('formEmail', 'E-mail'),
      submit: phsText('formSubmit', 'Aanmelden'),
      close: phsText('formClose', 'Sluiten'),
      teaser: phsText('formTeaser', '10% Introductiekorting?'),
      required: phsText('formRequired', 'Dit veld is verplicht'),
      invalidEmail: phsText('formInvalidEmail', 'Vul een geldig e-mailadres in')
    };
    const map = [
      [/^\s*10%\s*Korting op je eerste bestelling\?\s*$/i, strings.heading],
      [/^\s*Schrijf je in en ontvang de beste tips en exclusieve aanbiedingen\.?\s*$/i, strings.body],
      [/^\s*Voornaam\s*$/i, strings.firstName],
      [/^\s*E-?mail\s*$/i, strings.email],
      [/^\s*(Submit|Subscribe|Sign up|Aanmelden)\s*$/i, strings.submit],
      [/^\s*(Close modal|Close|Sluiten)\s*$/i, strings.close],
      [/^\s*10%\s*Introductiekorting\?\s*$/i, strings.teaser],
      [/^\s*Introductiekorting\s*$/i, strings.teaser],
      [/^\s*10%\s*Korting\s*$/i, strings.teaser],
      [/^\s*(This field is required|Dit veld is verplicht)\.?\s*$/i, strings.required],
      [/^\s*(Please enter a valid email|Enter a valid email|Vul een geldig e-mailadres in)\.?\s*$/i, strings.invalidEmail]
    ];
    const replaceValue = (raw) => {
      const value = String(raw || '');
      for (const [re, next] of map) {
        if (!re.test(value) || value.trim() === next) continue;
        return value.replace(re, next);
      }
      return null;
    };
    const walk = (node) => {
      if (!node) return;
      if (node.nodeType === 3) {
        const next = replaceValue(node.textContent);
        if (next != null) node.textContent = next;
        return;
      }
      if (node.nodeType === 1) {
        ['aria-label', 'placeholder'].forEach((attr) => {
          const cur = node.getAttribute(attr);
          if (!cur) return;
          const next = replaceValue(cur);
          if (next != null) node.setAttribute(attr, next);
        });
        if (node.tagName === 'INPUT' && /^(submit|button)$/i.test(node.type || '')) {
          const next = replaceValue(node.value);
          if (next != null) node.value = next;
        }
        if (node.shadowRoot) walk(node.shadowRoot);
      }
      if (node.childNodes && node.childNodes.length) {
        Array.from(node.childNodes).forEach(walk);
      }
    };
    const hosts = qsa('shopify-forms-embed', root && root.querySelectorAll ? root : document);
    if (hosts.length) hosts.forEach((host) => walk(host));
    else walk(root && root.nodeType ? root : document);
  }

  qsa('[data-lp-buy]').forEach((card) => {
    const btn = qs('[data-quick-add]', card);
    const price = qs('[data-lp-price]', card);
    const unit = qs('[data-lp-unit]', card);
    card.addEventListener('change', (e) => {
      const input = e.target.closest('input[type="radio"]');
      if (!input || !btn) return;
      btn.dataset.variantId = input.value;
      if (price && input.dataset.price) price.textContent = input.dataset.price;
      if (unit && input.dataset.unit) unit.textContent = input.dataset.unit;
    });
  });

  qsa('[data-lp-filter]').forEach((filter) => {
    const section = filter.closest('[data-lp-shampoo]') || document;
    filter.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-lp-hair]');
      if (!chip) return;
      const hair = chip.dataset.lpHair;
      qsa('[data-lp-hair]', filter).forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      qsa('.lp-shampoo__grid [data-lp-buy]', section).forEach((card) => {
        const cell = card.parentElement;
        cell.hidden = Boolean(hair) && card.dataset.hair !== hair;
        if (!cell.hidden) cell.classList.add('is-in');
      });
    });
  });

  localizeFormUi(document);
  const formsObserver = new MutationObserver(() => localizeFormUi(document));
  formsObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(() => localizeFormUi(document), 1500);
})();
